import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { registerNotificationToken } from './v3/Common/API/Firebase/action';


const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: 'humbee-84370.firebaseapp.com',
  projectId: 'humbee-84370',
  storageBucket: 'humbee-84370.appspot.com',
  messagingSenderId: '71139044859',
  appId: '1:71139044859:web:d499cf157bb0cbe2356f5e',
};

// Initialize Firebase and messaging only if the browser supports required APIs
let firebaseApp;
let messaging;

if ('serviceWorker' in navigator && 'PushManager' in window) {
  firebaseApp = initializeApp(firebaseConfig);
  messaging = getMessaging(firebaseApp);
} else {
  console.error(
    'This browser does not support the required APIs for Firebase Messaging.',
  );
}

export { messaging };

export const fetchToken = async (setTokenFound) => {
  // Exit if messaging is not supported
  if (!messaging) {
    console.error('Firebase Messaging is not supported in this environment.');
    return;
  }

  try {
    localStorage.removeItem('message_token');
    const currentToken = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
    });

    if (currentToken) {
      localStorage.setItem('message_token', JSON.stringify(currentToken));

      // Request notification permission
      const requestPermission = async () => {
        try {
          const permission = await Notification.requestPermission();
          if (permission === 'granted') {
            console.log('Notification permission granted.');
          } else {
            console.log('Notification permission not granted.');
          }
        } catch (err) {
          console.error('Error requesting notification permission:', err);
        }
      };
      await requestPermission();

      // Register token with your backend
      await registerNotificationToken(currentToken, 'userToken');
    } else {
      console.log('No registration token available.');
    }
  } catch (err) {
    console.error('Error retrieving token:', err);
  }
};
